import { gql, TypedDocumentNode } from "@apollo/client";

import { ManagedUserGroup } from "types/generated";

export const GET_API_KEY_GROUPS_COMBOBOX: TypedDocumentNode<{
  managedUserGroups: Pick<ManagedUserGroup, "groupName">[];
}> = gql`
  query GetApiKeyGroupsCombobox {
    managedUserGroups {
      groupName
    }
  }
`;
